import React, { Component } from 'react'
import { Field } from 'redux-form'

class InputField extends Component {
  constructor(props) {
    super(props)
    this.state = {
      charsRemaining: props.maxLength,
    }
  }

  componentDidMount() {
    const { name, maxLength } = this.props
    if (this.refs[name] && this.refs[name].value) {
      this.setState({
        charsRemaining: maxLength - this.refs[name].value.length,
      })
    }
  }

  getCharsRemaining = event => {
    const field = event.target
    const charsRemaining = field.value
      ? field.maxLength - field.value.length
      : field.maxLength
    this.setState({ charsRemaining })
  }

  render() {
    const { label, name, type = 'text', maxLength, disabled } = this.props
    const { charsRemaining } = this.state
    return (
      <div className="TextareaField">
        <label>{label}</label>
        <Field
          name={name}
          type={type}
          parse={type === 'number' ? value => Number(value) : undefined}
          component="input"
          maxLength={maxLength}
          onKeyUp={this.getCharsRemaining}
          disabled={disabled}
          ref={name}
        />
        {charsRemaining >= 0 && (
          <span className="remainingChars">
            {charsRemaining} characters remaining
          </span>
        )}
      </div>
    )
  }
}

export default InputField
